import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import Avatar from '@mui/material/Avatar';
import { Link as RouterLink } from 'react-router-dom';

// Define the names and routes of the pages.
const pagesName = ['About'];
const pagesRouting = ['/about'];

/**
 * ResponsiveAppBar component renders a responsive navigation bar with menu options.
 *
 * @component
 */
function ResponsiveAppBar() {
  const [anchorElNav, setAnchorElNav] = React.useState(null);

  /**
   * Handles opening the navigation menu.
   *
   * @param {Event} event - The event that triggered the menu opening.
   */
  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  /**
   * Handles closing the navigation menu.
   */
  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    <AppBar position="static">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Typography
            variant="h6"
            noWrap
            component={RouterLink}
            to="/"
            style={{ color: 'inherit', textDecoration: 'none' }}
            sx={{ mr: 2, display: { xs: 'none', md: 'flex' } }}
          >
            Passport Bros Aggregator
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              {pagesName.map((page, index) => (
                <MenuItem
                  key={page.toLowerCase()}
                  onClick={handleCloseNavMenu}
                  component={RouterLink}
                  to={pagesRouting[index]}
                  style={{ textDecoration: 'none' }}
                >
                  <Typography textAlign="center">{page}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>

          <Typography
            component={RouterLink}
            to="/"
            style={{ textDecoration: 'none' }}
            variant="h6"
            noWrap
            sx={{
              flexGrow: 1,
              display: {
                xs: 'flex', md: 'none', my: 2, color: 'white', display: 'block',
              },
            }}
          >
            Passport Bros Aggregator
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {pagesName.map((page, index) => (
              <Button
                key={page}
                component={RouterLink}
                to={pagesRouting[index]}
                style={{ textDecoration: 'none' }}
                onClick={handleCloseNavMenu}
                sx={{ my: 2, color: 'white', display: 'block' }}
              >
                {page}
              </Button>
            ))}
          </Box>

          {/* Invisible Avatar and Menu */}
          <Box sx={{
            flexGrow: 0, visibility: 'hidden', display: 'flex', flexDirection: 'column',
          }}
          >
            <Tooltip title="Open settings">
              <IconButton sx={{ p: 0 }}>
                <Avatar alt="Remy Sharp" src="/static/images/avatar/2.jpg" />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: '45px', visibility: 'hidden' }}
              id="menu-appbar"
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
            />
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default ResponsiveAppBar;
